import { useTranslation } from "@opendash/i18n";
import { Source } from "@opendash/plugin-parse/dist/types-generated";
import { FixedDescription } from "@opendash/ui";
import { Divider, Empty, Flex, Modal, Typography } from "antd";
import Parse from "parse";
import React, { useEffect, useMemo } from "react";
import { FileDescription } from "../..";
import { Media, Source_File } from "../../../../js/parsegenerated";

type Props = {
  open?: boolean;
  onClose?: () => void;
  sources?: Source[];
};
export default (props: Props) => {
  const [files, setFiles] = React.useState<Map<Source, Media[]>>(new Map());
  const t = useTranslation();

  useEffect(() => {
    if (!props.sources) return;
    getFiles();

    async function getFiles() {
      const sourceFileMap = new Map<Source, Media[]>();
      for (const key in props.sources) {
        const source = props.sources[key];

        const sourceFile = await new Parse.Query(Source_File)
          .equalTo("source", source)
          .first();
        if (!sourceFile) continue;

        const files = await sourceFile.files.query().find();
        if (files.length === 0) continue;

        sourceFileMap.set(source, files);
      }
      setFiles(sourceFileMap);
    }
  }, [props.sources]);

  const fileRows = useMemo(() => {
    if (!files) return null;
    const sourceFiles: Array<{ fileList: Media[]; source: Source }> = [];

    files.forEach((fileList, source) => {
      sourceFiles.push({ fileList, source });
    });

    return sourceFiles.map((sourceFile, index, array) => {
      return (
        <Flex vertical gap="8px" key={sourceFile.source.id}>
          <Typography.Title level={4}>
            {sourceFile.source.get("name")}
          </Typography.Title>
          {sourceFile.fileList.map((file) => {
            return <FileDescription key={file.id} fileData={file} />;
          })}
          {index !== array.length - 1 && <Divider />}
        </Flex>
      );
    });
  }, [files]);

  return (
    <Modal
      title={t("maintenance:knowledge.files.modal.title", {
        source: props?.sources
          ?.map((source) => source?.get("name"))
          ?.join(", "),
      })}
      open={props.open}
      onCancel={() => props.onClose && props.onClose()}
      onOk={() => props.onClose && props.onClose()}
      width="80%"
    >
      {fileRows.length === 0 && (
        <Empty description={t("maintenance:knowledge.files.modal.no_files")} />
      )}
      <FixedDescription>
        <Flex vertical gap="8px">
          {fileRows}
        </Flex>
      </FixedDescription>
    </Modal>
  );
};
